import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import { ImageResult } from 'ngx-image2dataurl';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import { saveAs } from 'file-saver';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-fuel',
  templateUrl: './fuel.component.html',
  styleUrls: ['../datatable.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class FuelComponent implements OnInit {
  
  ngOnInit(){}
 
} 